import { SERVICE } from './constants'

export const FETCH = `${SERVICE}/FETCH`
export const ERROR = `${SERVICE}/ERROR`
export const SUCCESS = `${SERVICE}/SUCCESS`

export const SET_DATA = `${SERVICE}/SET_DATA`
export const CLEAR_DATA = `${SERVICE}/CLEAR_DATA`
export const UPDATE_DATA = `${SERVICE}/UPDATE_DATA`

export const SET_COUNT = `${SERVICE}/SET_COUNT`
export const CLEAR_COUNT = `${SERVICE}/CLEAR_COUNT`

export const REMOVE_ALL = `${SERVICE}/REMOVE_ALL`
export const REMOVE_ALL_ERROR = `${SERVICE}/REMOVE_ALL_ERROR`
export const REMOVE_ALL_SUCCESS = `${SERVICE}/REMOVE_ALL_SUCCESS`

export const REMOVE = `${SERVICE}/REMOVE`
export const REMOVE_ERROR = `${SERVICE}/REMOVE_ERROR`
export const REMOVE_SUCCESS = `${SERVICE}/REMOVE_SUCCESS`

export const FAKE_READ_ALL = `${SERVICE}/FAKE_READ_ALL`
export const READ_ALL = `${SERVICE}/READ_ALL`
export const READ_ALL_ERROR = `${SERVICE}/READ_ALL_ERROR`
export const READ_ALL_SUCCESS = `${SERVICE}/READ_ALL_SUCCESS`

export const MARK = `${SERVICE}/MARK`
export const MARK_ERROR = `${SERVICE}/MARK_ERROR`
export const MARK_SUCCESS = `${SERVICE}/MARK_SUCCESS`
